import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { TitleTextLarge } from 'Packages/FacetDesign/Components';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LottieControl } from 'Organisms/LottieControl';
import fr from 'facet-rest';
import { useLottieLoadingContext } from 'Organisms/LottieControl/LottieLoadingLayout';
import ErrorList from 'Components/UI/ErrorList';

const MobileLayout = ({ errors }) => {
  const { resource } = useMetaLayoutContext();
  const { setIsContentShowing } = useLottieLoadingContext();

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (
    <FDStack direction="column" spacing={3} paddingY={4} justifyContent={'center'} alignItems={'center'} width={'100%'}>
      <FDStack direction="column" justifyContent={'center'} alignItems={'center'} spacing={2}>
        <MetaField attr="title" />
        <MetaField attr="subtitle" />
      </FDStack>
      <FDStack direction="column" spacing={2}>
        <TitleTextLarge align={'center'} value={'Account you’re moving money from'} />
        <MetaField attr="originAccountInstitution" />
        <MetaField attr="originAccountOtherName" />
        <MetaField attr="originAccountNumber" />
        <MetaField attr="originAccountType" />
        <MetaField attr="contributionsType" />
      </FDStack>
      <ErrorList title={'Errors occurred while submitting'} errors={errors} />

      {resource.withRelationship(fr.relationships.transferLottieVertical.name,
        (rel) => (
          <LottieControl
            src={rel.link('related').url()}
            onLoadSuccess={() => setIsContentShowing(true)}
            onLoadError={() => setIsContentShowing(true)}
            height={'auto'}
            width={'200px'}
          />
        ),
        () => null)}

      <FDStack direction={'row'} justifyContent={'center'} spacing={2} width={'100%'} maxWidth={'355px'}>
        <MetaField attr="destinationAccountName" />
        <MetaField attr="secondaryDestinationAccountName" />
      </FDStack>
    </FDStack>
  );
};

MobileLayout.defaultProps = {
  errors: [],
};

MobileLayout.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object),
};

export default MobileLayout;
